'use strict';

window.TAREFA_TIPOS = [
  { id: 0, descricao: 'Geral', tipo: 'geral', icon: 'fa fa-globe' },
  { id: 1, descricao: 'Stand', tipo: 'stand', icon: 'icon-stand' },
  { id: 2, descricao: 'Produtividade', tipo: 'produtividade', icon: 'icon-production' },
  { id: 3, descricao: 'Monitoria (Ocorrências)', tipo: 'ocorrencia', icon: 'icon-ocurrences' },
  { id: 4, descricao: 'Aferição de Semeadura', tipo: 'semeadura_afericao', icon: 'fa fa-calculator' }
];

window.TAREFA_STATUS = [
  { id: 0, descricao: 'pendente', labelClassColor: 'label-warning', label: 'Pendente', color: 'warning' },
  { id: 1, descricao: 'andamento', labelClassColor: 'label-success', label: 'Em Andamento', color: 'success' },
  { id: 2, descricao: 'finalizado', labelClassColor: 'label-success', label: 'Finalizado', color: 'success' },
  { id: 3, descricao: 'atrasado', labelClassColor: 'label-danger', label: 'Atrasado', color: 'danger' }
];

window.ICON_MARKER_TAREFA = {
  previsto: `${ICON_ALERT_PATH }icon_tarefa_amarelo.png`,
  realizado: `${ICON_ALERT_PATH }icon_tarefa_concluida.png`
};

window.CIRCLE_COLOR = {
  previsto: '#f1c40f',
  realizado: '#2ECC71'
};

window.RADIUS_TASK_CIRCLE = 25;
window.FULL_OPACITY = 1;

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('TarefasService', function($http, $q, filterFilter, TarefaObjectService,
  RestService, GoogleMapsService, LeafletService, $filter) {
  const getValueMarkerTask = function(position, draggable, icon) {
    return {
      id: position.id || null,
      idKey: Math.random(),
      position: position,
      options: {
        animation: google.maps.Animation.DROP,
        draggable: draggable,
        icon: {
          url: icon
        }
      }
    };
  };

  return {
    getTarefaStatus: function(descricao) {
      return filterFilter(TAREFA_STATUS, { descricao: descricao }, true)[0] || {};
    },

    isTipoStand: function(tipo) {
      return _.get(tipo, 'tipo') === _.get(TarefaObjectService.getTarefaTipo('stand'), 'tipo');
    },

    isTipoProdutividade: function(tipo) {
      return _.get(tipo, 'tipo') === _.get(TarefaObjectService.getTarefaTipo('produtividade'), 'tipo');
    },

    isTipoOcorrencia: function(tipo) {
      return _.get(tipo, 'tipo') === _.get(TarefaObjectService.getTarefaTipo('ocorrencia'), 'tipo');
    },

    //TODO Rever
    // eslint-disable-next-line complexity
    list: function(filters) {
      const params = !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        responsavel: (filters.responsavel || {}).id || null,
        encarregados: (filters.encarregados || []).map((encarregado) => encarregado.id) || null,
        usuario: (filters.usuario || {}).id || null,
        tipo: (filters.tipo || {}).tipo || null,
        status: (filters.status || {}).id
      };

      return RestService.getFromUrl(`${SERVER + API_VERSION}tarefas`, params);
    },

    get: function(id, editable) {
      const deferred = $q.defer();
      const _this = this;

      $http.get(`${SERVER + API_VERSION}tarefas/${id}`).then(function(result) {
        const object = TarefaObjectService.convertToObject(result.data);


        object.markers = _this.createMarkersTasks(null, object.pontos || [], editable);
        object.markersRealized = _this.createMarkersRealizedTasks(object);

        deferred.resolve(object);
      }, deferred.reject);

      return deferred.promise;
    },

    save: function(tarefa, shouldRepeat, repetition) {
      repetition = repetition || []; // avoids type error
      const bulk = shouldRepeat && repetition.length > 0;
      let result = TarefaObjectService.convertToSend(tarefa, shouldRepeat, bulk);
      if (bulk) {
        result = [result].concat(repetition.map((repeat) => {
          const task = angular.copy(result, {});
          task.data_inicial = $filter('date')(repeat.date, DATE_FORMAT);
          task.data_final = $filter('date')(repeat.date, DATE_FORMAT);
          task.tipo = repeat.tipo.tipo;
          return task;
        }));
        return this.sendBulk(result);
      }
      return this.send(result);
    },

    update: function(tarefa) {
      const result = TarefaObjectService.convertToSend(tarefa);
      return this.sendUpdate(result);
    },

    close: function(tarefa) {
      return $http({
        method: 'POST',
        url: `${SERVER}${API_VERSION}tarefas/${tarefa.id}/encerrar_tarefa`
      });
    },

    send: function(tarefa) {
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION}tarefas`,
        data: { tarefa: tarefa }
      });
    },

    sendBulk(tarefas = []) {
      const promises = tarefas.map((tarefa) => this.send(tarefa));
      return $q.all(promises);
    },

    sendUpdate: function(tarefa) {
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION}tarefas/${tarefa.id}`,
        data: { tarefa: tarefa }
      });
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION}tarefas/${id}`);
    },

    //todo - rever
    // eslint-disable-next-line max-lines-per-function, max-params
    createMarkerTask: function(position, map, draggable, index) {
      const iconMarker = GoogleMapsService.getIconForNumberMarker(index, CIRCLE_COLOR.previsto.substring(1));
      let marker = getValueMarkerTask(position, draggable, iconMarker);
      marker.map = map;
      marker = new google.maps.Marker(marker);

      return marker;
    },

    createLeafletMarkerTask: function({ position, draggable, index }) {
      const icon = LeafletService.createIconByNumber(index, CIRCLE_COLOR.previsto.substring(1));
      const marker = LeafletService.createMarker(position, icon);
      marker.options.draggable = draggable;
      return marker;
    },

    createMarkersTasks: function(markers, coordinatesPath, draggable) {
      const coordinates = Array.isArray(coordinatesPath) ? coordinatesPath : [coordinatesPath];

      return (markers || []).concat(coordinates.map(function(data) {
        return getValueMarkerTask(data, draggable, ICON_MARKER_TAREFA.previsto);
      }));
    },

    createMarkersRealizedTasks: function(object) {
      return (object.pontosRealizados || []).map(function(data) {
        const objeto = JSON.parse(data.objeto);
        return getValueMarkerTask(objeto, false, ICON_MARKER_TAREFA.realizado);
      });
    },

    addListener: function(object, placeMarker, event) {
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          google.maps.event.addListener(object[key], (event || 'click'), function(e) {
            placeMarker(e.latLng);
          });
        }
      }
    },

    removeTaskMarkers: function(taskMarkers) {
      if ((taskMarkers.markers || []).length > 0) {
        taskMarkers.markers.forEach(function(marker) {
          if (marker.circle) {
            marker.circle.setMap(null);
          }

          marker.setMap(null);
        });
      }
    },

    removeListener: function(object) {
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          google.maps.event.clearListeners(object[key], 'click');
        }
      }
    },

    getTaskStatusDescription(task) {
      const today = moment();
      if (task.status === 'pendente' && today.isAfter(task.data_final, 'day')) {
        return 'atrasado';
      }
      return task.status;
    },

    getDefaultValues: function(params) {
      return $http.get(`${SERVER + API_VERSION}tarefas/ultimo_registro`, { params });
    }
  };
});
